import { Button, Image } from '@smartgift/frontend-toolkit';
import styled from 'styled-components';

import { DEVICE } from '@hero/constants';

const ErrorPageImage = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
`;

const ErrorPageInformation = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const ErrorPageActions = styled.div`
  align-items: center;
  display: flex;
  gap: 24px;
  justify-content: center;

  ${DEVICE.mobile.max} {
    flex-direction: column;
    gap: 8px;
    width: 100%;

    ${Button.S.Button} {
      width: 100%;
    }
  }
`;

const ErrorPage = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  height: 100%;
  max-height: 100%;
  position: relative;
  width: 100%;

  ${Image.S.Image} {
    max-height: 160px;
  }

  ${DEVICE.mobile.max} {
    gap: 16px;

    ${Image.S.Image} {
      max-width: 100%;
    }
  }
`;

export { ErrorPage, ErrorPageActions, ErrorPageImage, ErrorPageInformation };
